import React, { useState } from "react";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import { Button, Image } from "hesus-ui-kit";
import RelatedContact from "./RelatedContact";
import AddRelatedContact from "./AddRelatedContact";
import errorIcon from "@icons/ic-error.svg";
import { Title, FlexRowHeader, ErrorDiv } from "../../AddEditQuote.styled";
import AddEditContact from "../../../../Contact/AddEditContact/AddEditContact";
import {
  ContactContainerOuter,
  ContactContainerInfo,
  FormBody,
  OptionsWrapper,
  SectionContainer,
  ContactInfo,
} from "./RelatedContact.styled";
import "../../AddEditQuote.scss";
import { RequiredMessage } from "@utils/extra-style";

const RelatedContactList = (props) => {
  const {
    t,
    id,
    isEditMode,
    selectedContacts,
    setSelectedContacts,
    statusDraft,
    companyId,
    contactErrorMessage,
    setContactErrorMessage,
    countryId,
  } = props;

  const [isAddContactPopupVisible, setAddContactPopupVisible] = useState(false);
  const [isAddConatct, setIsAddConatct] = useState(false);

  const updateRelatedContact = () => {
    setAddContactPopupVisible(true);
  };

  const onClose = () => {
    setAddContactPopupVisible(false);
  };

  const openViewPopUp = () => {
    setIsAddConatct(true);
    setAddContactPopupVisible(false);
  };

  const toogleViewPopUp = () => {
    setIsAddConatct(false);
    setAddContactPopupVisible(true);
  };

  return (
    <>
      <ContactContainerOuter>
        <ContactContainerInfo>
          <FlexRowHeader>
            <Title>{t("QUOTE_CONTACTS")}</Title>
            {!statusDraft && (
              <Button
                onClick={updateRelatedContact}
                styles={{
                  backgroundColor: "white",
                  color: "#008395",
                  border: "1px solid #008395",
                  height: "auto",
                  width: "auto",
                  padding: "1px 4px 1px 4px",
                  "&:hover": {
                    backgroundColor: "white",
                  },
                }}
              >
                {t("QUOTE_ADD_CONTACTS")}
              </Button>
            )}
          </FlexRowHeader>
          <FormBody>
            <OptionsWrapper>
              <SectionContainer>
                {selectedContacts.length > 0 &&
                  selectedContacts.map((contactInfo, index) => {
                    return (
                      <RelatedContact
                        contactData={contactInfo}
                        statusDraft={statusDraft}
                        key={
                          "related_conatc_list" +
                          index +
                          contactInfo?.id +
                          Math.random()
                        }
                        selectedContacts={selectedContacts}
                        setSelectedContacts={setSelectedContacts}
                        type="list"
                        setContactErrorMessage={setContactErrorMessage}
                      />
                    );
                  })}
                {selectedContacts.length === 0 && (
                  <ContactInfo color="#767676">
                    {t("QUOTE_NO_CONTACT")}
                  </ContactInfo>
                )}
                {selectedContacts.length === 0 && contactErrorMessage && (
                  <ErrorDiv>
                    <RequiredMessage>
                      <Image
                        src={errorIcon}
                        alt="warning"
                        className="add-quote__image-icon"
                      />{" "}
                      {contactErrorMessage}
                    </RequiredMessage>
                  </ErrorDiv>
                )}
              </SectionContainer>
            </OptionsWrapper>
          </FormBody>
        </ContactContainerInfo>
      </ContactContainerOuter>
      {isAddContactPopupVisible && (
        <AddRelatedContact
          companyId={companyId}
          onClose={onClose}
          selectedContacts={selectedContacts}
          setSelectedContacts={setSelectedContacts}
          openViewPopUp={openViewPopUp}
          setContactErrorMessage={setContactErrorMessage}
        />
      )}
      {isAddConatct && (
        <AddEditContact
          title={t("Contact")}
          onClose={toogleViewPopUp}
          page="relatedContact"
          companyId={companyId}
          countryId={countryId}
        />
      )}
    </>
  );
};

RelatedContactList.propTypes = {
  t: PropTypes.func.isRequired,
  id: PropTypes.number,
  isEditMode: PropTypes.bool,
};
RelatedContactList.defaultProps = {
  id: null,
  isEditMode: false,
};

export default withTranslation()(RelatedContactList);
